import ApiService from './api.service'
import axios from 'axios'

const UsersService = {
	getUsers: function (data) {
		return ApiService.post('/user/list', {...data});
	},
	createUser(resource) {
		return ApiService.post('/user/add-user', {...resource});
	},
	deleteUser: function (userId) {
		return ApiService.delete(`/user/${userId}`);
	},
	updateUserById: function (payload) {
		return axios.put(`/user/password-change/${payload.id}`, payload);
	},
	updateUserSelfPassword: function (payload) {
		return axios.put(`/user/password-change`, payload);
	},
	updateUserByRoles: function (payload) {
		return axios.post(`/user/add-role/${payload.id}`, payload);
	},
	updateUserByEmployee: function (payload) {
		return axios.get(`/user/employee/${payload.id}/${payload.employeeId.id}`);
	},
	updateUserByContragent: function (payload) {
		return axios.get(`/user/contragent/${payload.id}/${payload.contragentId.id}`);
	},
	updateUserStatusById: function (payload) {
		return axios.put(`/user/status/${payload.id}`, payload);
	},
	getUserById: function (userId) {
		return ApiService.get(`/user/${userId}`)
	},
	getPermittedDepartmentsById: function (userId) {
		return ApiService.get(`/user/get-permitted-departments/${userId}`)
	},
	getPermittedDepartments: function (userId = null) {
		return ApiService.get(`/department/get-my-departments`)
	},
	getSellerEmployees: function (search) {
		return ApiService.get(`/employee/any/list/kpi?search=${search}`)
	},

	postPermittedDepartmentsById: function (idAndPayload) {
		return ApiService.post(`/user/permit-to-departments/${idAndPayload.id}`, idAndPayload.payload);
	}

};

export default UsersService
